module.exports = __webpack_public_path__ + "static/media/Chapter8.d570e04e.pdf";